import { render, staticRenderFns } from "./LazyItem.vue?vue&type=template&id=700ceaa0&"
import script from "./LazyItem.vue?vue&type=script&lang=js&"
export * from "./LazyItem.vue?vue&type=script&lang=js&"
import style0 from "./LazyItem.vue?vue&type=style&index=0&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports